import React from 'react';
import Notification from './';

export default () => <Notification>Saved &#10003;</Notification>;
